import { Table, Pagination, Button, Popconfirm, Tag } from "antd";
import { MdInfoOutline } from "react-icons/md";
function DataTable(props) {
  const columns = [
    { title: "ID", dataIndex: "id", key: "id" },
    {
      title: "Active",
      dataIndex: "active",
      key: "active",
      render: (active) => (
        <Tag color={active ? "green" : "red"}>
          {active ? "Active" : "Inactive"}
        </Tag>
      ),
    },
    {
      title: "Name",
      dataIndex: "",
      key: "",
      render: (item) => (
        <div>
          {item.user && item.user.name} <MdInfoOutline />
        </div>
      ),
    },
    {
      title: "Rate / KG",
      dataIndex: "rate_per_kg",
      key: "rate_per_kg",
    },
    {
      title: "Third Party",
      dataIndex: "is_third_party_agent",
      key: "is_third_party_agent",
      render: (is_third_party_agent) => (
        <Tag color={is_third_party_agent ? "green" : "red"}>
          {is_third_party_agent ? "Yes" : "No"}
        </Tag>
      ),
    },
    {
      title: "",
      render: (item) => (
        <div className="tableAction">
          <Popconfirm
            placement="bottomRight"
            title={"Are you sure to delete?"}
            okText="Yes"
            cancelText="No"
            onConfirm={() => props.delete(item)}
          >
            <Button size="small">Delete</Button>
          </Popconfirm>
          <Button
            size="small"
            onClick={() => props.update(item)}
            type="primary"
          >
            Edit
          </Button>
        </div>
      ),
    },
  ];
  return (
    <div style={{ minHeight: "60vh" }}>
      <Table
        columns={columns}
        dataSource={props.data}
        pagination={false}
        size="small"
      />
      <br />
      <div align="right">
        <Pagination
          responsive
          defaultCurrent={props.meta && props.meta.page}
          total={props.meta && props.meta.itemCount}
          pageSize={props.meta && props.meta.take ? props.meta.take : 0}
          onChange={props.PageOnchange}
          pageSizeOptions={[10, 20, 50]}
        />
      </div>
    </div>
  );
}
export default DataTable;
